import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, SubmissionError} from 'redux-form';

import {login} from 'api/index';
import {loginSucceeded, loginFailed} from 'actions/index';

import LoginForm from '../components/login/LoginForm.jsx';

import {validateLoginForm as validate} from 'utils/validator';

const LOGIN_ERROR = 'Incorrect email or password';

@reduxForm({
  validate,
  form: 'loginForm',
  fields: ['email', 'password'],
  onSubmit: (values, dispatch) => {
    return login(values).catch(err => {
      throw new SubmissionError({_error: LOGIN_ERROR});
    });
  },
  onSubmitFail: (result, dispatch) => {
    dispatch(loginFailed(LOGIN_ERROR));
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch(loginSucceeded());
  }
})
export default class LoginPage extends Component {
  render() {
    return <LoginForm {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/containers/LoginPage.jsx